import { BlockitEnvSchema } from '@blockit/config/blockitEnv';
import { applyDevOverrides, DEV_WEB_CONFIG, PROD_WEB_CONFIG, STAGING_WEB_CONFIG } from '@blockit/config/web';

/**
 * The consuming app's `vite.config.ts` defines `import.meta.env.BLOCKIT_ENV`; the `VITE_*` overrides
 * are set only by a local dev server.
 */
const blockitEnv = BlockitEnvSchema.parse(import.meta.env.BLOCKIT_ENV);

// Compares the inlined value against literals, not the enum object, so the bundler folds each branch
// and drops every other environment's config from the bundle.
const selectCommittedConfig = () => {
  if (import.meta.env.BLOCKIT_ENV === 'prod') {
    return PROD_WEB_CONFIG;
  }
  if (import.meta.env.BLOCKIT_ENV === 'staging') {
    return STAGING_WEB_CONFIG;
  }
  return DEV_WEB_CONFIG;
};

export const webConfig = applyDevOverrides({
  blockitEnv,
  config: selectCommittedConfig(),
  devOverrides: {
    apiUrl: import.meta.env.VITE_API_URL || null,
    slackAppClientId: import.meta.env.VITE_SLACK_APP_CLIENT_ID || null,
  },
});
